
$views.upgrade = {
	
	display : function() {
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.upgrade.js